import { Id, PagedMultiSelectField, laravelSelectFetchConfig } from "@dgs/core";
import { FC, useMemo } from "react";
import { createUserTenantsService } from "../api/userService";

interface Props {
	name: string;
	label: string;
	required?: boolean;
	userId: Id;
}
export const UserTenantMultiSelect: FC<Props> = ({ name, label, required, userId }) => {
	const service = useMemo(() => createUserTenantsService(userId), [userId]);

	return (
		<PagedMultiSelectField
			name={name}
			label={label}
			required={required}
			fetchConfig={laravelSelectFetchConfig(service.tenantOptionsByUserKey, (search, page) =>
				service.tenantOptionsByUser(search, page).then((x) => x.data),
			)}
		/>
	);
};
